import { CallcardButtonTool, ICallcardButtonEvent } from '@addins/core/singlecallcard';

export class NavigateToTool extends CallcardButtonTool<ICallcardButtonEvent> {
  constructor() {
    super('NavigateToDest', 'navigate-sharp', 500);
  }
}
